import { lazy } from "react";

export const BusinessTripRequestPage = lazy(
  () => import("./business-trip-request"),
);
export {
  REQUEST_BUSINESS_TRIP_CREATE_PATH,
  REQUEST_BUSINESS_TRIP_EDIT_PATH,
} from "./business-trip-request-path";
export { ToBusinessTripRequest } from "./to-business-trip-request";
